import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-typing-loader-text',
  templateUrl: './typing-loader-text.component.html',
  styleUrls: ['./typing-loader-text.component.scss']
})
export class TypingLoaderTextComponent {
  @Input() text: string = 'Loading products, please wait...';
   get characters(): string[] {
    return this.text.split(/(\s+)/g); // preserve spaces as separate elements
  }
}
